export default "__VITE_ASSET__7cd689c2__"